import * as React from 'react';
import { Carousel } from '../Carousel';
import { IImageInfo } from '../../types/newbuilding';
import { ISlideProps } from '../Carousel/Carousel';
import { Image } from '../Image';
import { CarouselBlock } from '../CarouselBlock';
import { Thumbnails } from '../Thumbnails';

interface IPromoSnippetCarouselProps {
  features: React.ReactNode;
  title: string;
  images: Pick<IImageInfo, 'thumbnailUrl' | 'fullUrl' | 'isDefault'>[];
  labels: React.ReactNode;
  url: string;
}

export function PromoSnippetCarousel({ features, images, title, labels, url }: IPromoSnippetCarouselProps) {
  return (
    <CarouselBlock
      isPromo={true}
      features={features}
      labels={labels}
      thumbnails={<Thumbnails images={images} />}
      url={url}
    >
      <Carousel
        isPromo={true}
        hasThumbnails={images.length > 3}
        slides={images.map(
          (img: IImageInfo, index: number) =>
            // eslint-disable-next-line react/display-name
            ({ visible }: ISlideProps) =>
              visible && (
                <Image
                  alt={`${index + 1}-я Фотография ${title}`}
                  src={img.thumbnailUrl || img.fullUrl}
                  objectFit="cover"
                  lazy={index !== 0}
                />
              ),
        )}
        defaultSlideIndex={images.findIndex((img: IImageInfo) => img.isDefault)}
      />
    </CarouselBlock>
  );
}
